<!-- Rebate Request - Measurement Committee - View Valid Granted Rebate -->
<div *ngIf="!isRequestSucceeded">
    <h2 class="sectionTitle">Rebate Request - Mark Request as Refunded</h2>
    <div *ngIf="formMode == 2" class="bs-callout bs-callout-info"> 
        <p>This Rebate Request has been marked as Refunded</p>
    </div>
    <!-- Rebate Request - Display Mode -->
    <app-rebate-request #rebateRequest (rebateRequestLoadedFlag)="onRebateRequestLoadedFlag($event)"></app-rebate-request>
    <div class="read-only-content">
        <div class="form-container">
            <div class="form-section">
                <h4 class="section-title">Mark Request as Refunded</h4>
                <!-- Ship IMO No -->
                <div class="form-group">
                    <label for="lblIMONo">Ship IMO No.</label>
                    <label class="form-control" name="IMONo" id="lblIMONo">{{rebateRequest?.rebateRequestLoaded?.IMONo}}</label>
                </div>
                <!-- Rebate File No -->
                <div class="form-group">
                    <label for="lblRebateFileNo">Rebate File No.</label>
                    <label class="form-control" name="RebateFileNo" id="lblRebateFileNo">{{rebateRequest?.rebateRequestLoaded?.RebateFileNumber}}</label>
                </div>
            </div>
        </div>
        <div class="form-container">
            <h4 class="section-title">Request Options</h4>
        </div>
        <!-- Options Grid -->
        <div class="table-responsive">
            <table class="table table-bordered table-striped table-services">
                <thead>
                    <tr>
                        <th><span>From</span></th>
                        <th><span>To</span></th>
                        <th><span>Rebate Percentage in Numbers</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let longHaulRequestOption of longHaulRequestFormulateDecisionResponse.LongHaulRequestOptionsFormulatedDecision; let i = index;">
                        <td>{{longHaulRequestOption.LastPortOfOrigin}}</td> <!--Phase1 Task21 Khattab-->
                        <td>{{longHaulRequestOption.FirstPortOfDestination}}</td>
                        <td>{{longHaulRequestOption.RebatePercentage}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div [class.read-only-content]="formMode == 2" class="form-container">
        <form name="form" #f="ngForm" style="width:100%;">
            <div class="form-section">
                <!-- Mark Refunded -->
                <div class="form-group">
                    <label for="chkMarkRefunded">Request Refunded</label>
                    <!-- <span *ngIf="formMode == 1" class="red"> *</span> -->
                    <div class="custom-checkbox">
                        <!-- <input type="checkbox" [(ngModel)]="longHaulRequestMarkRefundedRequest.IsRefunded" name="MarkRefunded" id="chkMarkRefunded" #MarkRefunded="ngModel" required [disabled]="formMode == 2"> -->
                        <input type="checkbox" [(ngModel)]="longHaulRequestMarkRefundedRequest.IsRefunded" name="MarkRefunded" id="chkMarkRefunded" [disabled]="formMode == 2">
                        <label for="chkMarkRefunded">Mark as Refunded</label>                                                
                    </div>
                    <!-- <div *ngIf="isFormSubmitted && MarkRefunded?.invalid" class="red">
                        <span *ngIf="MarkRefunded?.errors?.required">This Field is Required</span>
                    </div> -->
                </div>
                <!-- Mark Closed -->
                <div class="form-group">
                    <label for="chkMarkClosed">Close Request</label>
                    <span *ngIf="formMode == 1" class="red"> *</span>
                    <div class="custom-checkbox">
                        <input type="checkbox" [(ngModel)]="longHaulRequestMarkRefundedRequest.IsClosed" name="MarkClosed" id="chkMarkClosed" #MarkClosed="ngModel" required [disabled]="formMode == 2">
                        <label for="chkMarkClosed">Close Request</label>                                                
                    </div>
                    <div *ngIf="isFormSubmitted && MarkClosed?.invalid" class="red">
                        <span *ngIf="MarkClosed?.errors?.required">This Field is Required</span>
                    </div>
                </div>
            </div>
            <div *ngIf="formMode == 1" class="form-group">
                <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="isFormSubmitted = true; f.form.valid && submit()">Submit</button>
                <button type="button" class="btn SCAcustomBtn" (click)="later()">Later</button>
            </div>
        </form>
    </div>
</div>
<!-- Confirmation -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 1" class="alert alert-success" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
                </g>
            </g>
        </svg>
        <p>You have Marked this Rebate Request as Refunded</p>
        <p>Go Back to <a routerLink="/RebateRequest/RequestsManagement">Requests Management</a></p>
    </div>
</div>
<!-- Warning -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 2" class="alert alert-warning" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
                </g>
            </g>
        </svg>
        <p>This task was submitted before</p>
        <p>Go Back to <a routerLink="/RebateRequest/RequestsManagement">Requests Management</a></p>
    </div>
</div>
<!-- Error -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 3" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>Something went wrong, Please contact System Administrator</p>
        <hr>
        <p>Go Back to <a routerLink="/workspace">Workspace</a></p>
    </div>
</div>